import React from 'react';
import { useParams, Link } from 'react-router-dom';
import CtaBand from '../components/CtaBand';
import { CASE_STUDIES } from '../data/cases';

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const study = CASE_STUDIES.find(c => c.slug === slug);

  if (!study) {
    return (
      <section className="section" style={{ textAlign: 'center', padding: '120px 0' }}>
        <div className="container">
          <h2>Case study not found</h2>
          <Link to="/case-studies" className="btn btn-primary" style={{ marginTop: 24, display: 'inline-flex' }}>
            ← Back to Case Studies
          </Link>
        </div>
      </section>
    );
  }

  return (
    <>
      {/* Hero */}
      <section className="page-hero page-hero--case-studies" style={{ padding: '80px 0 70px' }}>
        <div className="container">
          <Link to="/case-studies" style={{ color: 'rgba(255,255,255,0.52)', fontSize: 13, display: 'inline-flex', alignItems: 'center', marginBottom: 20, marginRight: 12, textDecoration: 'none' }}>
            <span aria-hidden="true" style={{ marginRight: 8 }}>←</span>
            <span>Case Studies</span>
          </Link>
          
          <div className="page-hero-kicker">{study.category} · {study.industry}</div>
          <h1 style={{ fontSize: 38, maxWidth: 720 }}>{study.title}</h1>
          <p style={{ maxWidth: 680, fontSize: 17, color: 'rgba(255,255,255,0.82)', fontStyle: 'italic', marginTop: 8 }}>{study.headline}</p>
          {(study.duration || study.team) && (
            <div style={{ display: 'flex', gap: 24, marginTop: 22, flexWrap: 'wrap' }}>
              {study.duration && <span style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13 }}>⏱ {study.duration}</span>}
              {study.team && <span style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13 }}>👥 {study.team}</span>}
            </div>
          )}
        </div>
      </section>

      {/* Metrics + Overview */}
      <section className="section" style={{ paddingBottom: 24 }}>
        <div className="container">
          <div className="split" style={{ alignItems: 'flex-start', gap: 56 }}>
            <div>
              <div className="kicker">Overview</div>
              <p style={{ fontSize: 16, lineHeight: 1.8, color: 'var(--ink)' }}>{study.overview}</p>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              {study.results.map((r, i) => (
                <div key={i} style={{
                  background: 'linear-gradient(135deg, #04122e, #061d45)',
                  borderRadius: 14, padding: '18px 14px', textAlign: 'center',
                  border: '1px solid rgba(13,183,232,0.2)',
                }}>
                  <div style={{ fontSize: 26, fontWeight: 900, color: '#0db7e8', fontFamily: 'var(--font-display)' }}>{r.metric}</div>
                  <div style={{ fontSize: 11.5, color: '#9ab6d8', marginTop: 5, lineHeight: 1.4 }}>{r.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Challenge + Approach */}
      <section className="section section-soft" style={{ padding: '52px 0' }}>
        <div className="container">
          <div className="split" style={{ gap: 56, alignItems: 'flex-start' }}>
            <div>
              <div className="kicker">The Challenge</div>
              <h2>What We Were Solving</h2>
              <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.8 }}>{study.challenge}</p>
            </div>
            <div>
              <div className="kicker">Our Approach</div>
              <h2>How We Solved It</h2>
              <ul className="check-list">
                {study.approach.map((step, i) => <li key={i}>{step}</li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Tech stack */}
      <section className="section" style={{ padding: '52px 0' }}>
        <div className="container">
          <div className="kicker">Technology Stack</div>
          <h2 style={{ marginBottom: 22 }}>Tools & Platforms Used</h2>
          <div className="tech-pills" style={{ gap: 10 }}>
            {study.tech.map((t, i) => (
              <span key={i} className="tech-pill" style={{ fontSize: 13, padding: '7px 16px', borderRadius: 20 }}>{t}</span>
            ))}
          </div>
        </div>
      </section>

      {/* Quote */}
      {study.quote && study.quoteAuthor && (
        <section style={{ background: 'linear-gradient(135deg, #04122e 0%, #061d45 40%, #082460 100%)', padding: '64px 0' }}>
          <div className="container" style={{ maxWidth: 740, textAlign: 'center' }}>
            <div style={{ fontSize: 52, color: '#0db7e8', lineHeight: 1, marginBottom: 14, opacity: 0.65 }}>&quot;</div>
            <p style={{ fontSize: 19, color: '#fff', lineHeight: 1.75, fontStyle: 'italic' }}>{study.quote}</p>
            <p style={{ color: '#9ab6d8', marginTop: 16, fontWeight: 600, fontSize: 14 }}>{study.quoteAuthor}</p>
          </div>
        </section>
      )}

      {/* CTA */}
      <CtaBand
        heading="Ready to Achieve Similar Results?"
        sub="Let's discuss your transformation goals."
        linkTo="/contact"
        linkLabel="Book a Consultation"
      />
    </>
  );
}
